import { Record } from 'immutable';
import { Err } from '../err';
import { actionTypes } from './program-permissions.actions';

export const ProgramEnrollmentReducerState = Record({
  err: null,
  isFetching: false,
  enrollment: null
});

export const programEnrollmentReducer = (state = new ProgramEnrollmentReducerState(), action) => {
  switch (action.type) {
    case actionTypes.FETCH_ENROLLED_PROGRAMS_BEGIN:
    case actionTypes.FETCH_ENROLLED_FORM_PERMISSIONS_BEGIN:
      return state.set('isFetching', true);
    case actionTypes.FETCH_ENROLLED_PROGRAMS_SUCCESS:
    case actionTypes.FETCH_ENROLLED_FORM_PERMISSIONS_SUCCESS:
      return state.set('enrollment', action.data)
                  .set('isFetching', false);
    case actionTypes.FETCH_ENROLLED_PROGRAMS_FAILURE:
    case actionTypes.FETCH_ENROLLED_FORM_PERMISSIONS_FAILURE:
      return state.set('enrollment', null)
                  .set('isFetching', false)
                  .set('err', new Err(action.error));
    case 'auth.logout':
    case 'auth.invalidate-current-session':
    case 'auth.invalidate-current-session-unobtrussive':
      return new ProgramEnrollmentReducerState();
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// src/programs/program-permissions.reducer.js